import React, { useState } from 'react';
import '../../styles/onboarding.css';

const ONBOARDING_KEY = 'trandi_onboarded';

export function isOnboardingDone() {
  try {
    return !!localStorage.getItem(ONBOARDING_KEY);
  } catch (e) {
    return true;
  }
}

export function markOnboardingDone() {
  try {
    localStorage.setItem(ONBOARDING_KEY, '1');
  } catch (e) {}
}

const STEPS = [
  {
    emoji: '👋',
    title: 'Добро пожаловать в Trandi!',
    text: 'Это мессенджер, где всё просто: сообщения, звонки, каналы и сторис. Пройдите короткий тур — и сразу в дело.',
  },
  {
    emoji: '💬',
    title: 'Чаты и переписка',
    text: 'Личные и групповые чаты, пересылка сообщений, реакции, запланированные сообщения и личные заметки «Своё».',
  },
  {
    emoji: '🤖',
    title: 'AI-ассистент MashaGPT',
    text: 'Откройте AI-ассистента в списке чатов: он отвечает на вопросы и генерирует картинки по описанию.',
  },
  {
    emoji: '📞',
    title: 'Звонки и медиа',
    text: 'Голосовые и видеозвонки, фото и видео, видеосообщения, стикеры и сторис — всё как вы привыкли.',
  },
  {
    emoji: '⚙️',
    title: 'Настройте под себя',
    text: 'В настройках — тема, цвета, профиль и документы. Всё готово! Нажмите «Начать» и пользуйтесь.',
  },
];

export default function OnboardingTour({ onFinish }) {
  const [step, setStep] = useState(0);
  const current = STEPS[step];
  const isLast = step === STEPS.length - 1;

  const finish = () => {
    markOnboardingDone();
    onFinish && onFinish();
  };

  return (
    <div className="modal-overlay onboarding-overlay">
      <div className="modal onboarding-modal" onClick={(e) => e.stopPropagation()}>
        <div className="onboarding-emoji">{current.emoji}</div>
        <h3 className="onboarding-title">{current.title}</h3>
        <p className="onboarding-text">{current.text}</p>
        <div className="onboarding-dots">
          {STEPS.map((s, i) => (
            <span key={i} className={`onboarding-dot${i === step ? ' active' : ''}`} />
          ))}
        </div>
        <div className="onboarding-actions">
          <button className="onboarding-skip" onClick={finish}>Пропустить</button>
          {step > 0 && (
            <button className="onboarding-back" onClick={() => setStep(step - 1)}>Назад</button>
          )}
          <button className="onboarding-next" onClick={() => (isLast ? finish() : setStep(step + 1))}>
            {isLast ? 'Начать' : 'Далее'}
          </button>
        </div>
      </div>
    </div>
  );
}
